"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var antd_1 = require("antd");
var OpacityField_1 = __importDefault(require("../Field/OpacityField/OpacityField"));
var RasterChannelEditor_1 = __importDefault(require("../RasterChannelEditor/RasterChannelEditor"));
var ContrastEnhancementField_1 = __importDefault(require("../Field/ContrastEnhancementField/ContrastEnhancementField"));
var GammaField_1 = __importDefault(require("../Field/GammaField/GammaField"));
var DataUtil_1 = __importDefault(require("../../../Util/DataUtil"));
var ColorMapEditor_1 = __importDefault(require("../ColorMapEditor/ColorMapEditor"));
var CompositionContext_1 = require("../../CompositionContext/CompositionContext");
var CompositionUtil_1 = __importDefault(require("../../../Util/CompositionUtil"));
require("./RasterEditor.css");
var _cloneDeep = require('lodash/cloneDeep');
var _get = require('lodash/get');
var RasterEditor = /** @class */ (function (_super) {
    __extends(RasterEditor, _super);
    function RasterEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.onOpacityChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.opacity = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onChannelEditorChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.channelSelection = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onContrastEnhancementChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            if (symbolizer.contrastEnhancement) {
                symbolizer.contrastEnhancement.enhancementType = value;
            }
            else {
                symbolizer.contrastEnhancement = {
                    enhancementType: value
                };
            }
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onGammaValueChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            if (symbolizer.contrastEnhancement) {
                symbolizer.contrastEnhancement.gammaValue = value;
            }
            else {
                symbolizer.contrastEnhancement = {
                    gammaValue: value
                };
            }
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onColorMapChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.colorMap = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        /**
         * Toggles the editor view. Switches from SymbolizerEditor to ChannelSelection
         * or ColorMap and back.
         */
        _this.toggleView = function (showDisplay) {
            _this.setState({
                showDisplay: showDisplay
            });
        };
        /**
         * Wraps a Form Item around a given element and adds its locale
         * to the From Item label.
         */
        _this.wrapFormItem = function (locale, element) {
            var formItemLayout = {
                labelCol: { span: 8 },
                wrapperCol: { span: 16 }
            };
            return element == null ? null : (React.createElement(antd_1.Form.Item, __assign({ label: locale }, formItemLayout), element));
        };
        _this.state = {
            showDisplay: 'symbolizer'
        };
        return _this;
    }
    RasterEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, locale = _a.locale, symbolizer = _a.symbolizer, internalDataDef = _a.internalDataDef, contrastEnhancementTypes = _a.contrastEnhancementTypes, colorRamps = _a.colorRamps;
        var opacity = symbolizer.opacity, contrastEnhancement = symbolizer.contrastEnhancement, colorMap = symbolizer.colorMap, channelSelection = symbolizer.channelSelection;
        var showDisplay = this.state.showDisplay;
        var sourceChannelNames;
        if (internalDataDef && DataUtil_1.default.isRaster(internalDataDef)) {
            sourceChannelNames = Object.keys(internalDataDef.rasterBandInfo);
        }
        var toggleViewButtonLayout = {
            wrapperCol: { span: 24 }
        };
        return (React.createElement(CompositionContext_1.CompositionContext.Consumer, null, function (composition) { return (React.createElement("div", { className: "gs-raster-symbolizer-editor" },
            showDisplay !== 'symbolizer' ? null : ([
                _this.wrapFormItem(locale.opacityLabel, CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'RasterEditor.opacityField',
                    onChange: _this.onOpacityChange,
                    propName: 'opacity',
                    propValue: opacity,
                    defaultElement: React.createElement(OpacityField_1.default, null)
                })),
                _this.wrapFormItem(locale.contrastEnhancementLabel, CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'RasterEditor.contrastEnhancementField',
                    onChange: _this.onContrastEnhancementChange,
                    propName: 'contrastEnhancement',
                    propValue: _get(contrastEnhancement, 'enhancementType'),
                    defaultElement: React.createElement(ContrastEnhancementField_1.default, null)
                })),
                _this.wrapFormItem(locale.gammaValueLabel, CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'RasterEditor.gammaValueField',
                    onChange: _this.onGammaValueChange,
                    propName: 'gamma',
                    propValue: _get(contrastEnhancement, 'gammaValue'),
                    defaultElement: React.createElement(GammaField_1.default, null)
                })),
                React.createElement(antd_1.Form.Item, __assign({ className: "gs-raster-editor-view-toggle", key: "toggleColorMap" }, toggleViewButtonLayout),
                    React.createElement("a", { onClick: function () { _this.toggleView('colorMap'); } }, locale.colorMapLabel + " >>")),
                React.createElement(antd_1.Form.Item, __assign({ className: "gs-raster-editor-view-toggle", key: "toggleContrastEnhancement" }, toggleViewButtonLayout),
                    React.createElement("a", { onClick: function () { _this.toggleView('contrastEnhancement'); } }, locale.channelSelectionLabel + " >>"))
            ]),
            showDisplay !== 'contrastEnhancement' ? null : ([
                CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'RasterEditor.rasterChannelField',
                    onChange: _this.onChannelEditorChange,
                    propName: 'channelSelection',
                    propValue: channelSelection,
                    defaultElement: (React.createElement(RasterChannelEditor_1.default, { sourceChannelNames: sourceChannelNames, contrastEnhancementTypes: contrastEnhancementTypes }))
                }),
                React.createElement(antd_1.Form.Item, __assign({ key: "toggleSymbolizer" }, toggleViewButtonLayout),
                    React.createElement("a", { onClick: function () { _this.toggleView('symbolizer'); } }, "<< " + locale.symbolizerLabel))
            ]),
            showDisplay !== 'colorMap' ? null : ([
                CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'RasterEditor.colorMapField',
                    onChange: _this.onColorMapChange,
                    propName: 'colorMap',
                    propValue: colorMap,
                    defaultElement: (React.createElement(ColorMapEditor_1.default, { colorRamps: colorRamps }))
                }),
                React.createElement(antd_1.Form.Item, __assign({ key: "toggleSymbolizer" }, toggleViewButtonLayout),
                    React.createElement("a", { onClick: function () { _this.toggleView('symbolizer'); } }, "<< " + locale.symbolizerLabel))
            ]))); }));
    };
    RasterEditor.componentName = 'RasterEditor';
    RasterEditor.defaultProps = {
        locale: en_US_1.default.GsRasterEditor
    };
    return RasterEditor;
}(React.Component));
exports.RasterEditor = RasterEditor;
exports.default = LocaleWrapper_1.localize(RasterEditor, RasterEditor.componentName);
//# sourceMappingURL=RasterEditor.js.map